import 'whatwg-fetch';
import qs from 'qs';
import { getApiHost } from 'src/envConfig';
import { checkAuthorization } from 'src/utils/checkAuthorization';
import { saveRedirectOrigin } from 'src/utils/saveRedirectOrigin';

const createUrl = (path, params, host) => {
	const urlBase = host ? host : `${getApiHost()}/api`;
	let url = `${urlBase}/${path}`;

	if (params) {
		url = url + '?' + qs.stringify(params);
	}

	return url;
};

const fetchWrapper = (url, options, suppressAuth) => {
	if (!suppressAuth && !checkAuthorization()) {
		saveRedirectOrigin(window.location.pathname);
		window.location.replace('/login');
		throw new Error('not authorized');
	}

	return fetch(url, options)
		.then(async response => {
			if (!response.ok) {
				throw await response.json();
			}
			return response.json();
		})
		.catch(err => {
			// if someone is trying to log in, we should just display the error
			if (err.code === 401 && window.location.pathname !== '/login') {
				window.location.replace('/login');
				throw new Error('not authorized');
			}
			throw err;
		});
};

export const getHandler = (path, params, host, suppressAuth) => {
	const url = createUrl(path, params, host);
	const headers = {};
	if (!suppressAuth) {
		headers['Authorization'] = `Bearer ${window.localStorage.wiselyToken}`;
	}

	return fetchWrapper(
		url,
		{
			headers,
			method: 'GET',
		},
		suppressAuth,
	);
};

export const postHandler = (path, body, params, host, suppressAuth) => {
	const url = createUrl(path, params, host);
	const headers = {
		'Content-Type': 'application/json',
	};
	if (!suppressAuth) {
		headers['Authorization'] = `Bearer ${window.localStorage.wiselyToken}`;
	}

	return fetchWrapper(
		url,
		{
			body,
			headers,
			method: 'POST',
		},
		suppressAuth,
	);
};

export const patchHandler = (path, body, params, host, suppressAuth) => {
	const url = createUrl(path, params, host);
	const headers = {
		'Content-Type': 'application/json',
	};
	if (!suppressAuth) {
		headers['Authorization'] = `Bearer ${window.localStorage.wiselyToken}`;
	}

	return fetchWrapper(
		url,
		{
			body,
			headers,
			method: 'PATCH',
		},
		suppressAuth,
	);
};

export const deleteHandler = (path, params, host, suppressAuth) => {
	const url = createUrl(path, params, host);
	const headers = {
		'Content-Type': 'application/json',
	};
	if (!suppressAuth) {
		headers['Authorization'] = `Bearer ${window.localStorage.wiselyToken}`;
	}

	return fetchWrapper(
		url,
		{
			headers,
			method: 'DELETE',
		},
		suppressAuth,
	);
};



// WEBPACK FOOTER //
// ./src/utils/fetchHandler.js